const {preloadMmbBase} = require('components/user_area/booking_info/mmb.preload');
const manageMyBookingModule = require('od-modules/manage_my_booking/manage_my_booking');
const Fetcher = require('od-modules/utils/fetcher');
const {getComponentFBM} = require('components/user_area/my_trips/js/utils/constants');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const {openChat, closeChat, sendResume, initChat} = require('od-modules/chat/chat_script');
const tagManagement = require('od-modules/utils/tag_management.utils');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const conchitaFactory = require('components/conchita/js/main');
const getFrontendBookingManagement = () => import('@edreamsodigeo/frontend-booking-management');
const {
    shouldRedirectToFbaMenu,
    buildFbaMenuRoute,
} = require('./desktop.handler.tripdetails_booking_management.redirect');

function getTrip(deeplinkToken) {
    const urlParams = new URLSearchParams();
    urlParams.append('td', deeplinkToken);

    return Fetcher.get(Odigeo.Settings.getProperty('serviceUsersFormatter')('encryptedTrip') + `?${urlParams.toString()}`).json();
}

const redirectToFbaMenu = (tdToken, autoChange, autoCancel) => {
    Odigeo.Router.navigate(buildFbaMenuRoute(tdToken, autoChange, autoCancel), {isOF2: true});
};

let loaded = false;

Odigeo.Router.handlers.tripdetails_booking_management = function(params) {
    const page = 'tripdetails_booking_management';
    const urlParams = Odigeo._.defaults({}, Odigeo.Utils.parseHashParameters(params));
    const {td: deeplinkToken, autoChange, autoCancel} = urlParams;
    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
    const token = deeplinkToken || tdToken;

    if (shouldRedirectToFbaMenu(urlParams) && token) {
        redirectToFbaMenu(token, autoChange, autoCancel);
        return;
    }

    $('#page').removeClass().addClass(page);
    this.widgetLoader = createWidgetLoader({
        conchita: ['conchita', conchitaFactory],
    });

    if (deeplinkToken || !loaded) {
        getTrip(token).then((res) => {
            const bookingInfo = res?.bookingDetailDTO;
            Odigeo.Session.set('bookingInfo', JSON.stringify(bookingInfo));
            loadConchita(bookingInfo, urlParams);
        });
        loaded = true;
    } else {
        configureMMBRouterEvents();
    }
};

function configureMMBRouterEvents() {
    Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
        {
            globalEvents: {},
            viewEvents: {
                'conchita:MMB:reloadTripDetails': 'onReloadTripDetails',
                'conchita:OpenTicket:Confirmation:goToTripDetails': 'onLightboxClose',
                'conchita:MMB:Accommodation:Confirmation:goToHome': 'onNavigateToHome',
                'conchita:MMB:MainMenu:Close': 'onLightboxClose',
                'conchita:MMB:MainMenu:goToPostBookingPrime': 'onMainMenuGoToPostBookingPrime',
                'conchita:MMB:CustomerSupport': 'onNavigateToCustomerSupport',
                'conchita:MMB:CancellationFlightSelector': 'onNavigateToCancellationFlightSelector',
                'conchita:MMB:ModificationOF2': 'onNavigateToModificationOF2',
                'conchita:MMB:ModificationStatusOF2': 'onNavigateToModificationStatusOF2',
                'conchita:MMB:NameChangeOF2': 'onNavigateToNameChangeOF2',
                'conchita:MMB:CancellationOF2': 'onNavigateToCancellationOF2',
                'conchita:MMB:ManagePreferredDatesOF2': 'onManagePreferredDatesOF2',
                'conchita:MMB:CancelForAnyReasonOF2': 'onNavigateToCancelForAnyReasonOF2',
                'conchita:MMB:CancellationSummaryLCC': 'onNavigateToCancellationSummaryLCC',
                'conchita:MMB:CancellationFlightSelectorLCC': 'onNavigateToCancellationFlightSelectorLCC',
                'conchita:MMB:CancellationStopoverSelectorLCC': 'onNavigateToCancellationStopoverSelectorLCC',
                'conchita:MMB:goToAlternativesFlow': 'onNavigateToAlternativesFlow',
                'conchita:MMB:goToAlternativesFlowOF2': 'onNavigateToAlternativesFlowOF2',
                'conchita:PBC:goToPrimeFreeCancellationOF2': 'onNavigatePrimeFreeCancellationOF2',
                'conchita:MMB:ModificationSummaryLC': 'onNavigateToModificationSummaryLC',
                'conchita:MMB:ModificationFlightSelectorLC': 'onNavigateToModificationFlightSelectorLC',
                'conchita:MMB:ModificationStopoverSelectorLC': 'onNavigateToModificationStopoverSelectorLC',
            },
            eventHandlers: {
                onReloadTripDetails: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`tripdetails/td=${tdToken}`);
                },
                onNavigateToHome: () => {
                    location.href = location.protocol + '//' + location.hostname;
                },
                onNavigateToCustomerSupport: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`categories/${tdToken}`);
                },
                onNavigateToCancellationFlightSelector: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`cnxflightselector/${tdToken}`);
                },
                onNavigateToModificationOF2: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`modify_flightselector/${tdToken}`);
                },
                onNavigateToModificationStatusOF2: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`modify_status/${tdToken}`);
                },
                onNavigateToNameChangeOF2: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`modify_changename_info/${tdToken}`);
                },
                onManagePreferredDatesOF2: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`modify_preferred_dates/${tdToken}`);
                },
                onNavigateToCancellationOF2: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`cnxsummary/${tdToken}`);
                },
                onNavigateToCancelForAnyReasonOF2: ({lowCost}) => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`cnxinfo/${lowCost ? 'lowcost/' : ''}${tdToken}`);
                },
                onNavigateToCancellationSummaryLCC: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`cnxlcc_summary/${tdToken}`);
                },
                onNavigateToCancellationFlightSelectorLCC: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`cnxlcc_flightselector/${tdToken}`);
                },
                onNavigateToCancellationStopoverSelectorLCC: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`cnxslcc_stopovers/${tdToken}`);
                },
                onNavigateToModificationSummaryLC: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`modifylc_change_trip/${tdToken}`);
                },
                onNavigateToModificationFlightSelectorLC: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`modifylc_your_flights/${tdToken}`);
                },
                onNavigateToModificationStopoverSelectorLC: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`modifylc_your_stopovers/${tdToken}`);
                },
                onNavigateToAlternativesFlow: () => {
                    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    loadConchita(bookingInfo, 'alternatives');
                },
                onNavigatePrimeFreeCancellationOF2: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`booking_cancellation/trip_management/${tdToken}`);
                },
                onNavigateToAlternativesFlowOF2: () => {
                    const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`alt_intro/${tdToken}`);
                },
                onLightboxClose: () => {
                    const {tdToken = ''} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                    Odigeo.Router.navigate(`sahome/${tdToken}`);
                },
                onMainMenuGoToPostBookingPrime: () => manageMyBookingModule.navigateOutside('primepostbooking'),
            },
        });

    Odigeo.Router.eventController.execute();
}

function loadConchita(bookingInfo, urlParams) {
    const isMobile = Odigeo.SessionScope.flow === 'mobile';
    const bookingId = bookingInfo.bookingBasicInfo.id;
    const bookingMail = bookingInfo.buyer.mail;
    const {funnel, autoChange, autoCancel} = urlParams;
    websiteConfigCollection.getLoadedPromise().then(() => {
        configureMMBRouterEvents();
        preloadMmbBase();
        getFrontendBookingManagement().then((bookingManagement) => {
            const bookingInfo = manageMyBookingModule.getBookingInfo(bookingId, bookingMail);

            this.widgetLoader.get('conchita')
                .execute('load', {
                    identifier: `conchita-manage-my-booking`,
                    container: `conchita-manage-my-booking`,
                    component: bookingManagement[getComponentFBM(false, funnel)],
                    translationPath: '/secure/translations/mmb',
                    data: {
                        bookingInfo,
                        isFirstPage: !isMobile,
                        withoutRedirect: true,
                        formatDate: Odigeo.Utils.formatDate,
                        openChat: openChat,
                        closeChat: closeChat,
                        sendResume: sendResume,
                        services: {
                            manageMyBooking: Odigeo.Settings.getProperty('manageMyBookingServiceUrlFormatter'),
                            bookingChangeRequest: Odigeo.Settings.getProperty('bookingChangeRequestServiceUrlFormatter'),
                            collectionMethod: Odigeo.Settings.getProperty('collectionMethodServiceUrlFormatter'),
                            modificationCheckout: Odigeo.Settings.getProperty('modificationCheckoutServiceUrlFormatter'),
                            bookingApi: Odigeo.Settings.getProperty('bookingApiServiceUrlFormatter'),
                            flightIncident: Odigeo.Settings.getProperty('flightIncidentServiceFBMUrlFormatter'),
                            unchainedMembershipPostbooking: Odigeo.Settings.getProperty('unchainedMembershipPostbookingServiceUrlFormatter'),
                        },
                        fireExternalEvent: tagManagement.fireExternalEvent,
                        autoChange: autoChange === 'true',
                        autoCancel: autoCancel === 'true',
                    },
                    conchitaLiveContent: true,
                    module: 'mmb',
                    basePath: 'tripdetails_booking_management',
                }).then(initChat());
        });
    });
}
